<section class="w-full flex flex-col items-center justify-center">
    <mat-card class="w-full max-h-[78vh] h-[78vh] lg:max-h-[82vh] lg:h-[82vh]  overflow-y-auto">
            <div class="px-6 py-8 grid">
                @if(!verifyPermissions.isAuthenticated()){
                    <div>
                        <p class="mb-2 text-sm font-semibold uppercase tracking-[0.3em] text-(--pg-brand-cyan)">Partner hub</p>
                        <h1 class="mb-3 text-3xl font-bold leading-tight text-(--pg-text)">Employee wellness and medical aid</h1>
                        <p class="mb-6 text-base leading-7 text-(--pg-text-muted)">
                            Momentum Health Solutions offers holistic tailor-made solutions for both employers and employees in South Africa.
                        </p>

                        <ul class="checklist mb-12">
                            <li>
                                <mat-icon class="check-icon">check_circle</mat-icon>
                                <span>Our <strong class="text-(--pg-text)">medical aid solutions</strong> give your employees access to healthcare benefits that costs less.</span>
                            </li>
                            <li>
                                <mat-icon class="check-icon">check_circle</mat-icon>
                                <span>We focus on <strong class="text-(--pg-text)">affordable health insurance solutions</strong> for your employees who cannot afford medical aid.</span>
                            </li>
                            <li>
                                <mat-icon class="check-icon">check_circle</mat-icon>
                                <span>Momentum Wellness focuses on <strong class="text-(--pg-text)">occupational hygiene, occupational health and safety, and employee wellness.</strong></span>
                            </li>
                        </ul>
                    </div>
                }
                <!-- <div class="flex flex-wrap gap-3 pt-6 items-end">
                    @if (canReadProfile()) {
                        <a mat-stroked-button routerLink="/users/profile">Open profile</a>
                    }
                    @if (canManageUsers()) {
                        <a mat-stroked-button routerLink="/user-management/users">Manage users</a>
                    }
                    @if (canReadEmployees()) {
                        <a mat-stroked-button routerLink="/employees">Manage employees</a>
                    }
                    @if (canReadClients()) {
                        <a mat-stroked-button routerLink="/clients">Open clients</a>
                    }
                    @if (!isAuthenticated()) {
                        <button mat-raised-button type="button" (click)="login()">Authenticate</button>
                    }
                </div> -->
                @if(verifyPermissions.isAuthenticated()){
                    <app-quick-menu [items]="menuItems"></app-quick-menu>
                }
            </div>
            <!-- <div>
                <img class="w-full rounded-r-2xl" src="assets/brand/health-lunch.jpg" alt="Healthy team at work" />
            </div> -->
    </mat-card>
</section>